import React, { useEffect, useState } from "react";
import CarbonCreditCard from "../atoms/CarbonCreditCard";
import AllCarbonCreditsLoader from "../molecules/AllCarbonCreditsLoader";
import { fetchProjects } from "../../utils/API/fetchProjects";
import useScrollToTop from "../../hooks/useScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InquireNotificationDialog from "../molecules/HomePageDialogs/InquireNotificationDialog";
import InquireConfirmation from "../molecules/HomePageDialogs/InquireConfirmation";
import BidNotificationDialog from "../molecules/HomePageDialogs/BidNotificationDialog";
import KycDialogBox from "../molecules/HomePageDialogs/KycDialogBox";
import { useSearchParams } from "react-router-dom";
import Pagination from "../atoms/Pagination";
import SearchFilterHeader from "../molecules/SearchFilterHeader";

const AllCarbonCreditPage = () => {
  useScrollToTop();
  const dispatch = useDispatch();
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userType, kycVerified } = useSelector((state) => state.authReducer);
  const [notificationDialogState, setNotificationDialogState] = useState(false);
  const [inquireNotificationState, setInquireNotificationState] = useState(false);
  const [kycDialogState, setKycDialogState] = useState(false);
  const [inquireConfirmState, setInquireConfirmState] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const [searchItem, setSearchItem] = useState("");
  const [filterData, setFilterData] = useState(null);

  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchProjects(
        {
          filterData: filterData,
          searchQuery: searchItem,
          page: currentPage,
          pageSize: 12,
        },
        dispatch
      );
      const responseData = response.data;
      setProjectData(responseData.paginatedData);
      const { totalDocs, totalPages } = responseData;
      setPagination({
        totalItems: totalDocs,
        totalPages: totalPages,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchItem, filterData]);

  const bidHandler = (url) => {
    if (userType === null) {
      setNotificationDialogState(true);
    } else if (userType === "seller") {
      setNotificationDialogState(true);
    } else if (!kycVerified) {
      setKycDialogState(true);
    } else {
      navigate(url);
    }
  };

  const InquireHandler = () => {
    if (userType === null) {
      setInquireNotificationState(true);
    } else if (userType === "seller") {
      setInquireNotificationState(true);
    } else if (!kycVerified) {
      setKycDialogState(true);
    } else {
      setInquireConfirmState(true);
    }
  };

  const renderRows = () => {
    const rows = [];

    if (projectData) {
      for (let i = 0; i < projectData.length; i += 4) {
        const rowProjects = projectData.slice(i, i + 4).map((project) => (
          <div className="w-fit" key={project.id}>
            <CarbonCreditCard
              bidHandler={bidHandler}
              InquireHandler={InquireHandler}
              {...project}
            />
          </div>
        ));

        rows.push(
          <div className="flex max-w-fit ml-4" key={i / 4}>
            {rowProjects}
          </div>
        );
      }
    }

    return rows;
  };

  return (
    <>
      <div className="bg-[#F4F6FA] min-h-screen flex flex-col justify-between">
        <div>
          <SearchFilterHeader
            heading={"Carbon Credits available"}
            searchItem={searchItem}
            setSearchItem={setSearchItem}
            filterData={filterData}
            setFilterData={setFilterData}
          />
          {loading ? <AllCarbonCreditsLoader /> : renderRows()}
        </div>
        <div className="mx-4">
          <Pagination
            className={"mb-4"}
            current={currentPage}
            total={pagination.totalItems}
            pageSize={12}
            setCurrentPage={(page) => setSearchParams({ page })}
          />
        </div>
      </div>
      <BidNotificationDialog
        open={notificationDialogState}
        isLoggedIn={userType !== null}
        onCancel={() => setNotificationDialogState(false)}
      />
      <InquireNotificationDialog
        open={inquireNotificationState}
        isLoggedIn={userType !== null}
        onCancel={() => setInquireNotificationState(false)}
      />
      <InquireConfirmation
        open={inquireConfirmState}
        onCancel={() => setInquireConfirmState(false)}
      />
      <KycDialogBox
        open={kycDialogState}
        onCancel={() => setKycDialogState(false)}
      />
    </>
  );
};

export default AllCarbonCreditPage;
